import { React, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useNavigate, useParams } from 'react-router-dom'

import { useGetByIdProductoMutation, useRemoveProductoMutation } from '../../../store/api/endpoints/productosApiSlice'

import { openFeedback } from '../../../store/slices/feedback'

import HeaderVista from '../../elementos/HeaderVista'
import Loading from '../../elementos/Loading'

import Button from '@mui/material/Button'
import { Breadcrumbs, Divider, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'

import DeleteIcon from '@mui/icons-material/Delete'
import StarOutlineIcon from '@mui/icons-material/StarOutline'

export default function ProductosEliminar() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const urlParams = useParams()


    const [
        getRegistro,
        {
            data: responseGetRegistro,
            isUninitialized: isUninitializedGetRegistro,
            isLoading: isLoadingGetRegistro,
            isSuccess: isSuccessGetRegistro,
            isError: isErrorGetRegistro,
            error: errorDataGetRegistro,
        }
    ] = useGetByIdProductoMutation()

    const [
        removeRegistro,
        {
            data: responseRemoveRegistro,
            isUninitialized: isUninitializedRemoveRegistro,
            isLoading: isLoadingRemoveRegistro,
            isSuccess: isSuccessRemoveRegistro,
            isError: isErrorRemoveRegistro,
            error: errorDataRemoveRegistro,
        }
    ] = useRemoveProductoMutation()

    useEffect(() => {
        getRegistro(urlParams.idProducto)
    }, [])

    useEffect(() => {
        if (isErrorGetRegistro) {
            dispatch(openFeedback({
                severity: 'error',
                message: errorDataGetRegistro.data.message
            }))
        }
    }, [isErrorGetRegistro])


    useEffect(() => {
        if (isErrorRemoveRegistro) {
            dispatch(openFeedback({
                severity: 'error',
                message: errorDataRemoveRegistro.data.message
            }))
        }
    }, [isErrorRemoveRegistro])

    useEffect(() => {
        if (isSuccessRemoveRegistro) {

            dispatch(openFeedback({
                severity: 'success',
                message: "¡Registro eliminado!"
            }))

            navigate("/productos")

        }
    }, [isSuccessRemoveRegistro])

    if (isUninitializedGetRegistro || isLoadingGetRegistro || isLoadingRemoveRegistro) return (<Loading />)
    if (isSuccessGetRegistro) return (
        <>
            <HeaderVista
                titulo={
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link to="/productos">
                            <Typography color="text.primary">Productos</Typography>
                        </Link>
                        <Typography color="text.primary">{responseGetRegistro.titulo}</Typography>
                        <Typography color="text.primary">Eliminar</Typography>
                    </Breadcrumbs>
                }
                icon={<StarOutlineIcon />}
            />
                <Grid container rowSpacing={2} columnSpacing={1}>
                    <Grid size={{ xs: 12, md: 3 }}></Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <h3>¿Eliminar producto?</h3>
                        <p><img src={responseGetRegistro.imagen} height={100} /></p>
                        <p>Se eliminará el producto <b>{responseGetRegistro.titulo}</b>.</p>
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <Divider />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <Button onClick={() => removeRegistro(urlParams.idProducto)} type="button" variant="contained" color="error" startIcon={<DeleteIcon />} >
                            Eliminar
                        </Button>
                    </Grid>
                </Grid>
        </>
    )

}